import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';
import { ModuleGuard } from './../../permission.guard';
import { Role } from './../../_models/role';
import { Permission } from './../../_models/permission';

// IMPORT COURSE MODULE COMPONENTS

import { CoursesComponent } from '../courses.component';
import { MaterialsComponent } from '../materials/materials.component';
import { UnitsComponent } from '../units/units.component';
import { MainCourseComponent } from './main-course.component';




const routes: Routes = [
  {
    path: '',
    component: MainCourseComponent,
    children: [
      {
        path: 'list',
        component: CoursesComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin], permission: [Permission.TrainingJob] }
      },
      {
        path: 'materials/:courseId',
        component: UnitsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'material/:courseId/:unitId',
        component: MaterialsComponent,
        canActivate: [AuthGuard],
      },
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainCourseRoutingModule { }
